import IntroPage from '@/views/main/IntroPage';
import NotFoundPage from '@/views/main/NotFoundPage';
import RoomsPage from '@/views/rooms/RoomsPage';
import RoomsInfoPage from '@/views/rooms/RoomsInfoPage';
import LightInfoPage from '@/views/rooms/LightInfoPage';
import LoginPage from '@/views/auth/LoginPage';
import JoinPage from '@/views/auth/JoinPage';
import CertPage from '@/views/auth/CertPage';
import CertCompletePage from '@/views/auth/CertCompletePage';
// import FindEmailPage from '@/views/auth/FindEmailPage';
import FindPasswordPage from '@/views/auth/FindPasswordPage';
import ChangePasswordPage from '@/views/auth/ChangePasswordPage';
import ChangePasswordCompletePage from '@/views/auth/ChangePasswordCompletePage';
import KakaoPage from '@/views/auth/callback/KakaoPage';
import GooglePage from '@/views/auth/callback/GooglePage';
import ApplePage from '@/views/auth/callback/ApplePage';
import DevicesPage from '@/views/devices/DevicesPage';
import AddDevicePage from '@/views/devices/AddDevicePage';
import AddZonePage from '@/views/zones/AddZonePage';
import AddRoomPage from '@/views/rooms/AddRoomPage';
import SchedulesPage from '@/views/schedules/SchedulesPage';
import ProfilePage from '@/views/users/ProfilePage';
import SharePage from '@/views/users/SharePage';
import DeleteUserPage from '@/views/users/DeleteUserPage';
import AppInfoPage from '@/views/application/AppInfoPage';
import AppUpdatePage from '@/views/application/AppUpdatePage';
import HomeSettingPage from '@/views/settings/HomeSettingPage';
import ControllerSettingPage from '@/views/settings/ControllerSettingPage';
import BleControllerSettingPage from '@/views/settings/BleControllerSettingPage';
import ControllerRegistPage from '@/views/settings/ControllerRegistPage';
import BleControllerRegistPage from '@/views/settings/BleControllerRegistPage';
import GroupSettingPage from '@/views/settings/GroupSettingPage';
import DeviceSettingPage from '@/views/settings/DeviceSettingPage';
import TransferPage from '@/views/settings/TransferPage';
import BatchSettingPage from '@/views/settings/BatchSettingPage';
import LightSettingPage from '@/views/settings/LightSettingPage';
import LightControllersSettingPage from '@/views/settings/LightControllersSettingPage';
import LightGroupsSettingPage from '@/views/settings/LightGroupsSettingPage';
import LightDevicesSettingPage from '@/views/settings/LightDevicesSettingPage';
import LightButtonListPage from '@/views/settings/LightButtonListPage';
import LightButtonMappingPage from '@/views/settings/LightButtonMappingPage';
import CurtainLinkedLightsPage from '@/views/settings/CurtainLinkedLightsPage';
import FadeSettingPage from '@/views/settings/FadeSettingPage';
import SwitchSensitivitySettingPage from '@/views/settings/SwitchSensitivitySettingPage';
import TempSettingPage from '@/views/settings/TempSettingPage';
import TempRegistPage from '@/views/settings/TempRegistPage';
import TempSettingListPage from '@/views/settings/TempSettingListPage';
import TempSchedulePage from '@/views/settings/TempSchedulePage';
import TempScheduleRegistPage from '@/views/settings/TempScheduleRegistPage';
import CurtainSettingPage from '@/views/settings/CurtainSettingPage';
import CurtainRegistPage from '@/views/settings/CurtainRegistPage';
import CurtainSettingListPage from '@/views/settings/CurtainSettingListPage';
import BlindRegistPage from '@/views/settings/BlindRegistPage';
import VirtualButtonSettingPage from '@/views/settings/VirtualButtonSettingPage';
import VirtualButtonUpdatePage from '@/views/settings/VirtualButtonUpdatePage';
import VirtualSettingPage from '@/views/settings/VirtualSettingPage';
import VirtualSettingRegistPage from '@/views/settings/VirtualSettingRegistPage';
import VirtualSettingUpdatePage from '@/views/settings/VirtualSettingUpdatePage';
import TransferRegistPage from '@/views/settings/TransferRegistPage';
import TransferChangeWifiPage from '@/views/settings/TransferChangeWifiPage';
import LightQrRegistPage from '@/views/settings/LightQrRegistPage';
import TransferChangeTempWifiPage from '@/views/settings/TransferChangeTempWifiPage';
import TransferSelectControllerPage from '@/views/settings/TransferSelectControllerPage';
import TransferChangeLightControllerPage from '@/views/settings/TransferChangeLightControllerPage';
import TransferChangeTempControllerPage from '@/views/settings/TransferChangeTempControllerPage';
import TransferSendPage from '@/views/settings/TransferSendPage';
import TransferReceivePage from '@/views/settings/TransferReceivePage';
import TransferReceiveLightPage from '@/views/settings/TransferReceiveLightPage';
import TransferReceiveTempPage from '@/views/settings/TransferReceiveTempPage';
import TransferInitZonePage from '@/views/settings/TransferInitZonePage';
import NoticePage from '@/views/notices/NoticePage';
const routes = [
  {
    path: '/',
    component: IntroPage,
  },
  {
    path: '/rooms',
    component: RoomsPage,
  },
  {
    path: '/rooms/:roomId',
    component: RoomsInfoPage,
  },
  // {
  //   path: '/rooms/:roomId/device/:id',
  //   component: LightInfoPage,
  // },
  {
    name: 'login',
    path: '/login',
    component: LoginPage,
  },
  {
    path: '/join',
    component: JoinPage,
  },
  // {
  //   path: '/find/email',
  //   component: FindEmailPage,
  // },
  {
    path: '/find/password',
    component: FindPasswordPage,
  },
  {
    path: '/change/password',
    component: ChangePasswordPage,
  },
  {
    path: '/change/password/complete',
    component: ChangePasswordCompletePage,
  },
  {
    path: '/auth/cert',
    component: CertPage,
  },
  {
    path: '/auth/cert/complete',
    component: CertCompletePage,
  },
  {
    path: '/oauth/kakao',
    component: KakaoPage,
  },
  {
    path: '/oauth/google',
    component: GooglePage,
  },
  {
    path: '/callback/apple',
    component: ApplePage,
  },
  {
    path: '/devices',
    component: DevicesPage,
  },
  {
    path: '/add/zone',
    component: AddZonePage,
  },
  {
    path: '/add/room',
    component: AddRoomPage,
  },
  {
    path: '/add/device',
    component: AddDevicePage,
  },
  {
    path: '/schedules',
    component: SchedulesPage,
  },
  {
    path: '/settings/zones',
    component: HomeSettingPage,
  },
  {
    path: '/settings/zones/:zoneId/groups',
    component: GroupSettingPage,
  },
  {
    path: '/settings/zones/:zoneId/regist-controllers',
    component: ControllerSettingPage,
  },
  {
    path: '/settings/zones/:zoneId/regist-ble-controllers',
    component: BleControllerRegistPage,
  },
  {
    path: '/settings/zones/:zoneId/setting-ble-controllers',
    component: BleControllerSettingPage,
  },
  {
    path: '/settings/zones/:zoneId/setting-controllers',
    component: ControllerSettingPage,
  },
  {
    path: '/settings/zones/:zoneId/groups/:groupId/devices',
    component: DeviceSettingPage,
  },
  {
    path: '/settings',
    component: TransferPage,
  },
  {
    path: '/settings/light',
    component: LightSettingPage,
  },
  {
    path: '/settings/light/controllers',
    component: LightControllersSettingPage,
  },
  {
    path: '/settings/light/groups',
    component: LightGroupsSettingPage,
  },
  {
    path: '/settings/light/groups/:groupId/devices',
    component: LightDevicesSettingPage,
  },
  {
    path: '/settings/light/groups/:groupId/buttons',
    component: LightButtonListPage,
  },
  {
    path: '/settings/light/groups/:groupId/buttons/new',
    component: LightButtonMappingPage,
  },
  {
    path: '/settings/light/groups/:groupId/buttons/:deviceId/edit',
    component: LightButtonMappingPage,
  },
  {
    path: '/settings/curtain/groups/:groupId/devices/:deviceId/linked-lights',
    component: CurtainLinkedLightsPage,
  },
  {
    path: '/settings/light/batch',
    component: BatchSettingPage,
  },
  {
    path: '/settings/light/fade',
    component: FadeSettingPage,
  },
  {
    path: '/settings/light/sensitivity',
    component: SwitchSensitivitySettingPage,
  },
  {
    path: '/settings/light/change/wifi',
    component: TransferChangeWifiPage,
  },
  {
    path: '/settings/light/regist/qr',
    component: LightQrRegistPage,
  },
  {
    path: '/settings/select/controller',
    component: TransferSelectControllerPage,
  },
  {
    path: '/settings/change/controller/light/:id',
    component: TransferChangeLightControllerPage,
  },
  {
    path: '/settings/change/controller/temp/:id',
    component: TransferChangeTempControllerPage,
  },
  {
    path: '/settings/regist',
    component: TransferRegistPage,
  },
  {
    path: '/settings/temp',
    component: TempSettingPage,
  },
  {
    path: '/settings/temp/regist',
    component: TempRegistPage,
  },
  {
    path: '/settings/temp/list',
    component: TempSettingListPage,
  },
  {
    path: '/settings/temp/change/wifi',
    component: TransferChangeTempWifiPage,
  },
  {
    path: '/settings/temp/schedule/:groupId/:deviceId',
    component: TempSchedulePage,
  },
  {
    path: '/settings/temp/schedule/:groupId/:deviceId/regist',
    component: TempScheduleRegistPage,
  },
  {
    path: '/settings/temp/schedule/:groupId/:deviceId/:scheduleId/:index/update',
    component: TempScheduleRegistPage,
  },
  {
    path: '/settings/curtain',
    component: CurtainSettingPage,
  },
  {
    path: '/settings/curtain/regist',
    component: CurtainRegistPage,
  },
  {
    path: '/settings/curtain/list',
    component: CurtainSettingListPage,
  },
  {
    path: '/settings/blind/regist',
    component: BlindRegistPage,
  },
  {
    path: '/settings/send',
    component: TransferSendPage,
  },
  {
    path: '/settings/receive',
    component: TransferReceivePage,
  },
  {
    path: '/settings/receive/light',
    component: TransferReceiveLightPage,
  },
  {
    path: '/settings/receive/temp',
    component: TransferReceiveTempPage,
  },
  {
    path: '/settings/init',
    component: TransferInitZonePage,
  },
  {
    path: '/setting/virtual/regist/:zoneId',
    component: VirtualSettingRegistPage,
  },
  {
    path: '/setting/virtual/update/:zoneId',
    component: VirtualSettingUpdatePage,
  },
  {
    path: '/setting/virtual',
    component: VirtualSettingPage,
  },
  {
    path: '/virtual/light/:groupId',
    component: VirtualButtonSettingPage,
  },
  {
    path: '/virtual/curtain/:groupId',
    component: VirtualButtonSettingPage,
  },
  {
    path: '/virtual/:groupId/:virtualId',
    component: VirtualButtonUpdatePage,
  },
  {
    path: '/profile',
    component: ProfilePage,
  },
  {
    path: '/share',
    component: SharePage,
  },
  {
    path: '/delete/user',
    component: DeleteUserPage,
  },
  {
    path: '/info',
    component: AppInfoPage,
  },
  {
    path: '/update',
    component: AppUpdatePage,
  },
  {
    path: '/notices',
    component: NoticePage,
  },
  {
    path: '/404',
    component: NotFoundPage,
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/404',
  },
];

export default routes;
